import React from 'react';

import cs from 'classnames';
import styled from 'styled-components';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {ShortcutKey} from 'app/general/shortcuts/ShortcutKey';
import {gt} from 'app/utils/i18n';

import {AnnotatedNavLinkType} from '../nav_links';

interface Props {
  navLink: AnnotatedNavLinkType;
  shortcutKey: string;
  homepage: boolean;
  secondary: boolean;
}
export function DraggableNavItem({
  homepage,
  navLink,
  shortcutKey,
  secondary,
}: Props): JSX.Element {
  return (
    <StyledContainerDiv>
      <div
        className={cs('ml-2 flex-grow d-flex align-items-center', {
          small: secondary,
        })}
      >
        <i
          className={`${
            navLink.iconType != null ? navLink.iconType : 'fa'
          } fa-fw fa-${navLink.icon} mr-2`}
        />
        <span>{navLink.title}</span>
      </div>
      <div className="d-flex align-items-center">
        {homepage ? (
          <LazyTooltip
            tooltip={gt('The first page you see when you open SweetProcess')}
          >
            <span className="badge rounded-pill px-2 bg-info text-white mr-3">
              {gt('home page')}
            </span>
          </LazyTooltip>
        ) : null}
        <ShortcutKey size={0.6}>{shortcutKey}</ShortcutKey>
        <div className="btn btn-link flex-shrink-0">
          <i className="fa fa-sort" />
        </div>
      </div>
    </StyledContainerDiv>
  );
}
const StyledContainerDiv = styled.div.attrs({
  className:
    'd-flex justify-content-between py-1 border-top border-bottom bg-white',
})`
  margin-top: -1px;
`;
